import React from "react";
import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";

import Avatar from "@components/Avatar";
import Body from "@components/typography/Body";
import WithPopover from "@components/WithPopover";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";

export type AvatarProps = {
  avatarTooltip?: React.ReactNode;
  avatarDeleteTooltip?: React.ReactNode;
  onAvatarClick?: (e: React.SyntheticEvent<any>) => void;
  onAvatarRemove?: (e: React.SyntheticEvent<any>) => void;
  entity: { AvatarPic?: string; Name?: string };
  avatarColor?: string;
};

export const ItemCardAvatar = ({
  avatarTooltip,
  avatarDeleteTooltip,
  entity = {},
  onAvatarClick,
  onAvatarRemove,
  avatarColor
}: AvatarProps) => {
  const classes = useStyles({});

  const avatar = (
    <Avatar
      className={classes.avatar}
      src={entity.AvatarPic}
      name={entity.Name}
      onClick={onAvatarClick}
      color={avatarColor}
      size="medium"
      style={{ paddingTop: 8 }}
    />
  );

  return avatarTooltip ? (
    <div className={classes.avatarTooltips}>
      {entity.AvatarPic ? (
        <WithPopover
          popoverContent={<Body>{avatarDeleteTooltip}</Body>}
          PopoverProps={{
            anchorOrigin: { horizontal: "center", vertical: "top" },
            transformOrigin: { horizontal: "center", vertical: "bottom" }
          }}
        >
          <IconButton className={classes.removeAvatarBtn} onClick={onAvatarRemove}>
            <Close fontSize="inherit" />
          </IconButton>
        </WithPopover>
      ) : null}

      <WithPopover
        popoverContent={<Body>{avatarTooltip}</Body>}
        PopoverProps={{
          anchorOrigin: { horizontal: "center", vertical: "bottom" },
          transformOrigin: { horizontal: "center", vertical: "top" }
        }}
      >
        {avatar}
      </WithPopover>
    </div>
  ) : (
    avatar
  );
};

const useStyles = makeStyles((theme: ThemeType) => ({
  avatarTooltips: {
    display: "flex",
    flexDirection: "column",
    position: "relative",

    "&:hover $removeAvatarBtn": {
      display: "block"
    }
  },

  avatarDelete: {
    position: "relative",
    background: "red"
  },

  avatar: {
    width: 32,
    height: 32
  },

  removeAvatarBtn: {
    fontSize: 10,
    padding: 5,
    display: "none",
    position: "absolute",
    right: -6,
    top: -3,
    zIndex: 1,
    background: theme.palette.danger?.main || theme.palette.error.main,
    color: "#fff",
    border: "2px solid #fff",
    "&:hover": {
      background: theme.palette.danger?.main || theme.palette.error.main
    }
  }
}));
